import * as React from "react";
import {useTheme, type Theme, type Components} from "../..";
import {accordionSummaryClasses} from "../../../components/AccordionSummary";
import AddIcon from "../../../icons/Add";
import RemoveIcon from "../../../icons/Remove";

type AccordionSummaryOverrides = Components<Theme>["MuiAccordionSummary"];

// Hack to ensure that we get title5 variant by default
// But we should still allow for setting a different variant to the summary
const getFirstChildVariant = (children: React.ReactNode) =>
    // @ts-expect-error - props is not guaranteed to exist in "React.ReactNode"
    Array.isArray(children) ? children?.[0]?.props?.variant : children?.props?.variant;

function ExpandIcon() {
    const theme = useTheme();

    return (
        <>
            <AddIcon
                sx={{
                    opacity: 1,
                    transition: theme.transitions.create(["opacity"], {
                        duration: theme.transitions.duration.enteringScreen,
                        easing: theme.transitions.easing.easeInOut,
                    }),
                    ".Mui-expanded &": {opacity: 0},
                }}
            />
            <RemoveIcon
                sx={{
                    opacity: 0,
                    transition: theme.transitions.create(["opacity"], {
                        duration: theme.transitions.duration.enteringScreen,
                        easing: theme.transitions.easing.easeInOut,
                    }),
                    ".Mui-expanded &": {opacity: 1},
                }}
            />
        </>
    );
}

const overrides: AccordionSummaryOverrides = {
    defaultProps: {
        expandIcon: <ExpandIcon />,
    },
    styleOverrides: {
        root: ({theme}) => ({
            position: "relative",
            padding: `0 ${theme.spacing(4)}`,

            [`&.${accordionSummaryClasses.expanded}`]: {
                minHeight: 48,
            },
        }),
        content: ({ownerState, theme}) => ({
            margin: `${theme.spacing(4)} 0`,
            [`&.${accordionSummaryClasses.expanded}`]: {
                margin: `${theme.spacing(4)} 0`,
            },
            ...(!getFirstChildVariant(ownerState.children) && {
                "& > *:first-child": {
                    ...theme.typography.title5,
                },
            }),
        }),
        expandIconWrapper: ({theme}) => ({
            position: "absolute",
            right: theme.spacing(3),
            top: "calc(50% - 12px)",
            width: 24,
            height: 24,

            "& > svg": {
                position: "absolute",
                right: 0,
                top: 0,
            },

            [`&.${accordionSummaryClasses.expanded}`]: {
                transform: "rotate(180deg)",
            },
        }),
    },
};

export default overrides;
